var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTask = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 20.25H11C10.59 20.25 10.25 19.91 10.25 19.5C10.25 19.09 10.59 18.75 11 18.75H21C21.41 18.75 21.75 19.09 21.75 19.5C21.75 19.91 21.41 20.25 21 20.25Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.25H11C10.59 13.25 10.25 12.91 10.25 12.5C10.25 12.09 10.59 11.75 11 11.75H21C21.41 11.75 21.75 12.09 21.75 12.5C21.75 12.91 21.41 13.25 21 13.25Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.25H11C10.59 6.25 10.25 5.91 10.25 5.5C10.25 5.09 10.59 4.75 11 4.75H21C21.41 4.75 21.75 5.09 21.75 5.5C21.75 5.91 21.41 6.25 21 6.25Z",
    fill: "#292D32"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.24994C3.81 7.24994 3.62 7.17994 3.47 7.02994L2.47 6.02994C2.18 5.73994 2.18 5.25994 2.47 4.96994C2.76 4.67994 3.24 4.67994 3.53 4.96994L4 5.43994L6.47 2.96994C6.76 2.67994 7.24 2.67994 7.53 2.96994C7.82 3.25994 7.82 3.73994 7.53 4.02994L4.53 7.02994C4.38 7.17994 4.19 7.24994 4 7.24994Z",
    fill: "#292D32"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 14.2499C3.81 14.2499 3.62 14.1799 3.47 14.0299L2.47 13.0299C2.18 12.7399 2.18 12.2599 2.47 11.9699C2.76 11.6799 3.24 11.6799 3.53 11.9699L4 12.4399L6.47 9.96994C6.76 9.67994 7.24 9.67994 7.53 9.96994C7.82 10.2599 7.82 10.7399 7.53 11.0299L4.53 14.0299C4.38 14.1799 4.19 14.2499 4 14.2499Z",
    fill: "#292D32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21.2499C3.81 21.2499 3.62 21.1799 3.47 21.0299L2.47 20.0299C2.18 19.7399 2.18 19.2599 2.47 18.9699C2.76 18.6799 3.24 18.6799 3.53 18.9699L4 19.4399L6.47 16.9699C6.76 16.6799 7.24 16.6799 7.53 16.9699C7.82 17.2599 7.82 17.7399 7.53 18.0299L4.53 21.0299C4.38 21.1799 4.19 21.2499 4 21.2499Z",
    fill: "#292D32"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTask, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/task.c2597b6c.svg";
export { ForwardRef as ReactComponent };